import { useTranslation } from 'react-i18next';
import { skyLightest } from '../../styles/design-tokens';
import { Tooltip } from '../../ui-library/tooltip/tooltip';
import { SmallSquareButton } from '../small-square-button/small-square-button';

type Props = {
  onClick: () => void;
  visible?: boolean;
};

export const ResetFiltersButton = ({ onClick, visible = true }: Props) => {
  const i18n = useTranslation();
  if (!visible) {
    return null;
  }

  return (
    <Tooltip variant="white" label={i18n.t('common.labels.reset_filters')} position="left">
      <SmallSquareButton
        onClick={onClick}
        iconName="restart_alt"
        style={{ backgroundColor: skyLightest, position: 'absolute', bottom: 0, right: 0 }}
        aria-label="Reset filters"
      />
    </Tooltip>
  );
};
